import { render } from "./DiscountBanner.vue?vue&type=template&id=12f360b1&scoped=true&ts=true"
import script from "./DiscountBanner.vue?vue&type=script&lang=ts"
export * from "./DiscountBanner.vue?vue&type=script&lang=ts"

import "./DiscountBanner.vue?vue&type=style&index=0&id=12f360b1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12f360b1"]])

export default __exports__